export function faqs() {
	const accordions = document.querySelectorAll('.site-faqs__accordion-faq');

	const openAccordion = (accordion) => {
		const answer = accordion.querySelector('.site-faqs__accordion-answer');
		//accordion.classList.add('site-faqs__accordion-faq--active');
		answer.style.maxHeight = answer.scrollHeight + 'px';
	};

	const closeAccordion = (accordion) => {
		const answer = accordion.querySelector('.site-faqs__accordion-answer');
		//accordion.classList.remove('site-faqs__accordion-faq--active');
		answer.style.maxHeight = null;
	};

	accordions.forEach((accordion) => {
		const question = accordion.querySelector('.site-faqs__accordion-question');
		const answer = accordion.querySelector('.site-faqs__accordion-answer');

		question.onclick = () => {
			if (answer.style.maxHeight) {
				closeAccordion(accordion);
			} else {
				accordions.forEach((acc) => closeAccordion(acc));
				openAccordion(accordion);
			}
		};
	});
}
